import {GenSystemNewsType} from '../../../../../generated/serverModels/GenSystemNewsType';

export class SystemNewsType extends GenSystemNewsType {
    public selected = false;

    constructor(systemNewsType?: SystemNewsType) {
        super(systemNewsType);
    }
}
